import ModalDialog from '@stone/components/modal/ModalDialog';
// import analytics from '@utils/analytics';
import api from '@utils/api';
import useQueryStringBoolean from '@utils/useQueryStringBoolean';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '@stone/ui/icon/Icon';
import { useLangChecker } from '@common/utils/i18n';
const LanguageModal = (props) => {
    const { t } = useTranslation();
    const [open, setOpen] = useQueryStringBoolean('localeselector');
    const [data, setData] = useState();
    useEffect(() => {
        if (open) {
            api.languageSelectorJson().then((data) => {
                setData(data);
            });
        }
    }, [open]);
    const handleColumn = (index) => {
        if (index < 4) {
            return 1;
        }
        else {
            if (index < data.length / 2) {
                return 1;
            }
            else {
                return 2;
            }
        }
    };
    const handleRow = (index) => {
        if (index < data.length / 2) {
            return index + 1;
        }
        else {
            return index - data.length / 2;
        }
    };
    const modal = () => (React.createElement(ModalDialog, { isOpen: open, onRequestClose: () => {
            setOpen(false);
            // analytics.languageselectorClose();
        }, hasDivisor: true, contentLabel: t('modal.language.title'), subtitle: t('modal.language.description'), className: "language-modal", fullWidth: true, fullHeight: true },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "languageselector-wrapper mt-32" },
                React.createElement("div", { className: "continent-title languageselector" },
                    React.createElement("ol", null, data.map((lang, index) => (React.createElement("li", { key: lang.link, className: `grid-column-${handleColumn(index)}` },
                        React.createElement("a", { href: lang.link, "aria-current": window.language === lang.language, "data-language": lang.language }, lang.name))))))))));
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: "footer-countrybutton", "aria-haspopup": "dialog", onClick: () => setOpen(true) },
            React.createElement("span", { className: "footer-countrybutton__content" },
                React.createElement("span", { className: "footer-countrybutton__title", ref: useLangChecker }, t('footer.item.language')),
                ' ',
                props.current),
            React.createElement(Icon, { name: "open", family: "10", inverted: true })),
        data && modal()));
};
export default LanguageModal;
